// There may be the case, that a modal is triggered as open, although it does not exist yet
const lazyModalCache = [];

export default {
    state: _ => {
        return {
            modals: {}
        }
    },
    mutations: {
        addModal(state, config) {
            if(typeof config !== "object") { return; }
            const name = config.name;
            const trigger = config.trigger;
            if(typeof name === "string" && typeof trigger === "function") {
                state.modals[config.name] = config.trigger;
            }
            if(lazyModalCache.includes(name)) {
                state.modals[name]();
            }
        },
        openModal(state, name) {
            if(Object.keys(state.modals).includes(name)) {
                state.modals[name]();
            } else {
                if(!lazyModalCache.includes(name)) lazyModalCache.push(name);
            }
        }
    },
    actions: {
        addModal(state, name, trigger) {
            state.commit("addModal", name, trigger);
        },
        openModal(state, name) {
            state.commit("openModal", name);
        }
    }
}